// @ts-nocheck
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnComplete,
} from "@insite/client-framework/HandlerCreator";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getQueryStrings } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { AddCartAllowanceApiParameter } from "@store/Framework/Types/ApiModels";
import { addCartAllowance } from "@store/Framework/Services/AllowanceService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

type Result = {
    errorMessage: string;
};

type HandlerType = ApiHandlerDiscreteParameter<
    {
        amount: string;
    } & HasOnComplete<Result>,
    AddCartAllowanceApiParameter,
    BaseModel,
    Result
>;

export const DispatchBeginApplyAllowance: HandlerType = props => {
    props.dispatch({
        type: "Pages/CheckoutReviewAndSubmit/BeginApplyAllowance",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState();
    const { cartId } = getQueryStrings(state);
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    if (!cart) {
        throw new Error("There was no current cart when we were trying to apply a allowance to it.");
    }

    props.apiParameter = {
        amount: props.parameter.amount,
    };
};

export const AddCartAllowance: HandlerType = async props => {
    const result = await addCartAllowance(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        props.errorMessage = result.errorMessage!;
    }
};

export const LoadCart: HandlerType = props => {
    const state = props.getState();
    const { cartId } = getQueryStrings(state);
    if (cartId) {
        props.dispatch(loadCart({ cartId }));
    } else {
        props.dispatch(loadCurrentCart());
    }
};

export const DispatchCompleteApplyAllowance: HandlerType = props => {
    props.dispatch({
        type: "Pages/CheckoutReviewAndSubmit/CompleteApplyAllowance",
        errorMessage: props.errorMessage,
    });
};

export const chain = [
    DispatchBeginApplyAllowance,
    PopulateApiParameter,
    AddCartAllowance,
    LoadCart,
    DispatchCompleteApplyAllowance,
];

const applyAllowance = createHandlerChainRunner(chain, "ApplyAllowance");
export default applyAllowance;
